import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Users, UserCheck, Clock, ArrowRight } from 'lucide-react';

interface GuestsWidgetProps {
  total: number;
  confirmed: number;
  pending: number;
  /** Asistentes de los invitados confirmados (fórmula única · headcount). */
  confirmedAttendees: number;
  /** Asistentes por confirmar = pases reservados de los pendientes. */
  pendingAttendees: number;
  /** Global = confirmados + pendientes (excluye rechazados). */
  expectedAttendees: number;
}

const GuestsWidget = ({
  total,
  confirmed,
  pending,
  confirmedAttendees,
  pendingAttendees,
  expectedAttendees,
}: GuestsWidgetProps) => {
  const stats = [
    {
      label: 'Total Invitados',
      value: total,
      sub: null,
      icon: Users,
      color: 'bg-primary/10 text-primary',
      iconBg: 'bg-primary/10',
    },
    {
      label: 'Confirmados',
      value: confirmed,
      sub: `${confirmedAttendees} asistentes`,
      icon: UserCheck,
      color: 'bg-secondary/10 text-secondary',
      iconBg: 'bg-secondary/10',
    },
    {
      label: 'Pendientes',
      value: pending,
      sub: `${pendingAttendees} asistentes`,
      icon: Clock,
      color: 'bg-accent/10 text-accent',
      iconBg: 'bg-accent/10',
    },
  ];

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-3 gap-3">
        {stats.map((stat) => (
          <Card key={stat.label} className="shadow-soft border-border/50 hover:shadow-card transition-shadow">
            <CardContent className="p-4 text-center">
              <div className={`w-10 h-10 rounded-full ${stat.iconBg} flex items-center justify-center mx-auto mb-3`}>
                <stat.icon className={`w-5 h-5 ${stat.color.split(' ')[1]}`} />
              </div>
              <p className="font-serif text-3xl font-medium text-foreground mb-1">
                {stat.value}
              </p>
              <p className="text-xs text-muted-foreground uppercase tracking-wider">
                {stat.label}
              </p>
              {stat.sub && (
                <p className="text-xs text-muted-foreground mt-1">{stat.sub}</p>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
      <p className="text-center text-sm text-muted-foreground">
        Asistentes esperados (confirmados + pendientes):{' '}
        <span className="font-medium text-foreground">{expectedAttendees}</span>
      </p>
      <div className="flex justify-center">
        <Button variant="outline" size="sm" asChild>
          <Link to="/dashboard/guests">
            Gestionar invitados
            <ArrowRight className="w-4 h-4 ml-2" />
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default GuestsWidget;
